import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { logoutGuardianUser } from "../../features/guardianUser.features";
import { loginUser } from "../../features/loggedInUser.features";
import { Role, User } from "../../generated/graphql";

interface stateProps {
  user?: User;
  clinics?: {
    __typename?: "Clinic";
    id: number;
    institutionName: string;
  }[];
  selectedRole?: Role;
}

const Div = styled.div`
  .text {
    font-size: 1.75rem;
    font-weight: bold;
  }

  .sub-text {
    font-size: 1rem;
    line-height: 1.375rem;
    font-weight: normal;
  }
`;

function ChooseHospital() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const state: stateProps = location.state;

  function handleChoice(i: number) {
    dispatch(
      loginUser({
        data: state?.user,
        role: state?.selectedRole,
        clinic: state?.clinics[i],
      })
    );
    dispatch(logoutGuardianUser());

    navigate(`/app/${state?.selectedRole.toLowerCase()}/home`, {
      replace: true,
    });
  }

  useEffect(() => {
    if (!state) navigate("/auth", { replace: true });
  }, [state, navigate]);

  return (
    <Div>
      <h1 className="text-gray-300 text mb-2">Select Hospital,</h1>
      <p className="text-gray-800 dark:text-gray-200 sub-text">
        Kindly choose from the options, which hospital you want to log in to.
      </p>

      <section className="mt-3">
        {state?.clinics.map((clinic, i) => (
          <button
            key={i}
            onClick={() => handleChoice(i)}
            className="flex justify-between p-4 mb-3 bg-[#B7D0FB]"
          >
            <p>{clinic.institutionName}</p>
            <p>select</p>
          </button>
        ))}
      </section>
    </Div>
  );
}

export default ChooseHospital;
